// GPS location opt-in toggle

interface LocationToggleProps {
  checked: boolean
  onChange: () => void
  disabled?: boolean
}

export default function LocationToggle({
  checked,
  onChange,
  disabled = false,
}: LocationToggleProps) {
  return (
    <label
      className={`
        flex items-center gap-3 cursor-pointer select-none
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
      `}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="sr-only"
      />
      <div
        className={`
          w-10 h-6 rounded-full transition-colors relative
          ${checked ? 'bg-green-500' : 'bg-gray-600'}
        `}
      >
        <div
          className={`
            w-4 h-4 bg-white rounded-full absolute top-1
            transition-transform
            ${checked ? 'translate-x-5' : 'translate-x-1'}
          `}
        />
      </div>
      <span className="text-sm text-gray-300 flex items-center gap-2">
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
        Include location
      </span>
    </label>
  )
}
